export default __webpack_public_path__ + "static/media/help-icon.211891a9.svg";